import { isEqual } from 'lodash';
import Store from 'src/store';
import getCurrentMode from './getCurrentMode';
import mainMenuPanel from './mainMenuPanel';
export default function setCurrentMode(params) {
    // handles legacy problems
    if (!('leftDrawerOpen' in params)) {
        params.leftDrawerOpen = mainMenuPanel.getOpen();
    }
    Store.dispatch('mode/setCurrentMode', params);
}
export function setCurrentMode2(setterParams) {
    const { targetMode, modeSetterParams } = setterParams;
    let modeToSet = Object.assign({}, targetMode);
    if (modeSetterParams.executeInsteadIfTargetModeIsCurrent) {
        const currentMode = getCurrentMode();
        const currentModeIsSameAsTargetMode = isEqual(Object.assign({}, currentMode), Object.assign(Object.assign({}, currentMode), targetMode));
        if (currentModeIsSameAsTargetMode) {
            modeToSet = modeSetterParams.executeInsteadIfTargetModeIsCurrent;
        }
    }
    setCurrentMode(modeToSet);
}
